const modelImages = {
  "111-111-140-BAL":
    "https://www.ikea.com/us/en/images/products/taennforsen-orrsjoen-bathroom-vanity-with-sink-faucet-white__1364261_pe955810_s5.jpg",
  "111-111-160-BAL":
    "https://www.ikea.com/us/en/images/products/taennforsen-orrsjoen-bathroom-vanity-with-sink-faucet-white__1217230_pe912626_s5.jpg",
  "111-111-180-BAL":
    "https://www.ikea.com/us/en/images/products/taennforsen-orrsjoen-bathroom-vanity-with-sink-faucet-white__1217245_pe912636_s5.jpg",
  "111-111-200-BAL":
    "https://www.ikea.com/us/en/images/products/taennforsen-orrsjoen-bathroom-vanity-with-sink-faucet-white__1217253_pe912646_s5.jpg",
  "111-111-90-SVI":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_900_light.png",
  "111-111-100-SVI":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1000_light.png",
  "111-111-110-SVI":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1100_light.png",
  "111-111-90-VID":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_900_mid.png",
  "111-111-100-VID":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1000_mid.png",
  "111-111-110-VID":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1100_mid.png",
  "111-111-90-TAM":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_900_dark.png",
  "111-111-100-TAM":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1000_dark.png",
  "111-111-110-TAM":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1100_dark.png",
  "111-111-90-TA2":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_900_dark2.png",
  "111-111-100-TA2":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1000_dark2.png",
  "111-111-110-TA2":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/vonios_spintele_1100_dark2.png",
  "222-222-180-SVI":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_1800_light.png",
  "222-222-210-SVI":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2100_light.png",
  "222-222-250-SVI":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2500_light.png",
  "222-222-180-VID":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_1800_mid.png",
  "222-222-210-VID":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2100_mid.png",
  "222-222-250-VID":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2500_mid.png",
  "222-222-180-TAM":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_1800_dark.png",
  "222-222-210-TAM":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2100_dark.png",
  "222-222-250-TAM":
    "https://s3.eu-central-1.amazonaws.com/products.baldaijng.lt/tv_staliukas_2500_dark.png",
};

export default modelImages;
